import type { FaireProductEntity } from "../../entity_types/product";

export const nyc_acc_7: FaireProductEntity = {
  token: "nyc-acc-7",
  type: "product",
  name: "NYC Skyline Print",
  brandName: "Manhattan Art Studio",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/b8b02598cf4e67e63c3dd309c38bc9ec235bc3e10272e9dd6dd6f1f470d0a781.webp",
  priceDollars: 45,
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/b8b02598cf4e67e63c3dd309c38bc9ec235bc3e10272e9dd6dd6f1f470d0a781.webp",
  weight: 0.5,
  dimensions: {
    width: 16,
    height: 20,
    depth: 0.5,
  },
  description: "Hand-illustrated NYC skyline print",
  categoryTokens: ["cat_accessories"],
  tags: ["nyc-local", "premium", "art", "home-decor"],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-compass-migration",
  },
};
